if (typeof isStatsigInitialized === "undefined") {
  window.isStatsigInitialized = false;
  window.initializationInProgress = false;
  window.initializationPromise = null;
  window.statsig = null;
}

function initSentry(appEnvironment) {
  Sentry.onLoad(function () {
    Sentry.init({
      environment: appEnvironment,
      beforeSend(event, hint) {
        const stacktrace = hint.syntheticException?.stack || "";

        // Filter by specific files
        if (
          stacktrace.includes("statsig.js") ||
          stacktrace.includes("gifter.js") ||
          stacktrace.includes("embed.js") ||
          stacktrace.includes("learn-more.js") ||
          stacktrace.includes("ribbonUtils.js")
        ) {
          return event;
        }
        return null;
      },
    });
  });
}

function sentryCaptureException(error, tags, extra) {
  if (typeof Sentry !== "undefined") {
    Sentry.captureException(error, {
      tags,
      extra,
    });
  }
}

async function initializeStatsig(appEnvironment, myShopifyDomain) {
  console.log("Initializing Statsig for", myShopifyDomain);

  try {
    initSentry(appEnvironment);
  } catch (error) {
    console.error("Error initializing Sentry:", error);
  }

  // If already initialized, return immediately
  if (window.isStatsigInitialized) {
    return;
  }

  // If initialization is in progress, wait for it to complete
  if (window.initializationInProgress) {
    return await window.initializationPromise;
  }

  // Set the lock and create a new initialization promise
  window.initializationInProgress = true;
  window.initializationPromise = (async () => {
    try {
      console.log("Initializing Statsig for", myShopifyDomain);

      const { StatsigClient, runStatsigAutoCapture, runStatsigSessionReplay } =
        window.Statsig;

      if (typeof StatsigClient !== "undefined") {
        const tier = appEnvironment === "production" ? "production" : "staging";

        // Use the customer UUID from ribbonUtils.js
        const customerUUID = window.ribbonUtils.getOrCreateCustomerUUID();

        window.statsig = new StatsigClient(
          "client-fLYNpJNxVgczMcRxmWbObiw8dfXOOwmi63ghj2Qfbog",
          {
            userID: customerUUID || "",
            custom: {
              shopDomain: myShopifyDomain,
            },
          },
          { environment: { tier: tier } },
        );

        try {
          runStatsigAutoCapture(window.statsig);
          runStatsigSessionReplay(window.statsig);
          await window.statsig.initializeAsync();
          window.isStatsigInitialized = true;
        } catch (error) {
          console.error("Error initializing Statsig:", error);

          sentryCaptureException(
            error,
            {
              location: "statsig_initialization",
              environment: appEnvironment,
            },
            {
              customerId: customerUUID,
              domain: window.location.hostname,
            },
          );

          throw error;
        }
      } else {
        const error = new Error("StatsigClient is not defined");
        console.error(error.message);
        Sentry.captureException(error, {
          level: "error",
          tags: { location: "statsig_missing_client" },
        });
        throw error;
      }
    } finally {
      // Always release the lock, even if there was an error
      window.initializationInProgress = false;
    }
  })();

  // Return the initialization promise
  return await window.initializationPromise;
}

function getMetadata(variantId, productId, additionalMetadata = {}) {
  return {
    variant_id: variantId,
    product_id: productId,
    customer_orders_count: statsigCustomerOrdersCount,
    cart_item_count: statsigCartItemCount,
    cart_subtotal: statsigCartSubtotal,
    ...additionalMetadata,
  };
}

function logEvent(eventName, eventValue, metadata) {
  if (window.statsig && window.isStatsigInitialized) {
    window.statsig.logEvent(eventName, eventValue, metadata);
  }
}

function logModalOpen(variantId, productId) {
  logEvent("gift_modal_opened", "", getMetadata(variantId, productId));
}

function logModalClose(variantId, productId) {
  logEvent("gift_modal_closed", "", getMetadata(variantId, productId));
}

function logSendMethodToggled(method, variantId, productId) {
  logEvent(
    "gift_send_method_toggled",
    method,
    getMetadata(variantId, productId),
  );
}

function logPhysicalGiftAdded(variantId, productId, properties) {
  logEvent(
    "physical_gift_added_to_cart",
    "",
    getMetadata(variantId, productId, properties),
  );
}

function logVirtualGiftAdded(variantId, productId, properties) {
  logEvent(
    "virtual_gift_added_to_cart",
    "",
    getMetadata(variantId, productId, properties),
  );
}

function logVirtualGiftAddFailed(variantId, productId, properties) {
  logEvent(
    "virtual_gift_add_to_cart_failed",
    "",
    getMetadata(variantId, productId, properties),
  );
}

async function getMerchantConfig() {
  if (window.statsig && window.isStatsigInitialized) {
    // Get the dynamic config for the merchant
    const config = await window.statsig.getDynamicConfig("merchant_config");
    console.log("Fetched merchant config:", config.value);
    return config.value;
  }
  return null;
}
